export default "__VITE_ASSET__CAbHCmSA__"